<div *ngIf="isHiddenField;else shownField" [formGroup]="form" >
    <input [formControlName]="formField.name" value="{{formField?.value}}" type="hidden">
  </div>
  <ng-template #shownField>
  <div [formGroup]="form" class="row form-field">
      <label *ngIf="!isHiddenField" [attr.for]="formField.key" class="col-sm-4 col-form-label">{{formField?.label}}</label>
      <div [ngSwitch]="formField.controlType" class="col-sm-8">
          <!-- <input *ngSwitchCase="'hidden'" [formControlName]="formField.name" value="{{formField?.value}}" type="hidden"> -->
          <input *ngSwitchCase="'display'" [formControlName]="formField.name" value="{{formField?.value}}" readonly nbInput fieldSize="small" class="display">
          <ng-container *ngSwitchCase="'textqbe'">
            <input [formControlName]="formField.name" [id]="formField.key" type="hidden" nbInput value="{{formField?.value}}">
            <ubs-ofbiz-textqbe-field [formField]="formField" (setTextQBEField)="setTextQBEField($event)" (openTextQBEDialogEvent)="openTextQBEDialog($event)"></ubs-ofbiz-textqbe-field>
          </ng-container>
          <ng-container *ngSwitchCase="'password'">
            <nb-form-field>
              <input [type]="getInputType()" nbInput  [formControlName]="formField.name"  [name]="formField.name">
              <button nbSuffix nbButton ghost (click)="toggleShowPassword()">
                <nb-icon [icon]="showPassword ? 'eye-outline' : 'eye-off-2-outline'"
                         pack="eva"
                         [attr.aria-label]="showPassword ? 'hide password' : 'show password'">
                </nb-icon>
              </button>
            </nb-form-field>
            <div *ngIf="formField.name == 'password' && form.get(formField.name).invalid && (form.get(formField.name).dirty || form.get(formField.name).touched)" class="alert alert-danger">
              <div *ngIf="form.get(formField.name).errors['pattern']">Field should contain at least 1 uppercase, 1 lowercase and 1 digit.</div>
            </div>
            <div *ngIf="formField.name == 'confirmPassword' && form.get(formField.name).invalid && (form.get(formField.name).dirty || form.get(formField.name).touched)" class="alert alert-danger">
              <div *ngIf="confirmPasswordControl.invalid">Passwords don't match.</div>
            </div>
  <!--             <div *ngIf="form.errors?.['PasswordNoMatch']" class="alert alert-danger">Password does'nt match.
            </div>
            <div *ngIf="form.errors?.['PasswordNoMatch'] && formField.name == 'confirmPassword' && (form.get(formField.name).dirty || form.get(formField.name).touched)" class="alert alert-danger">Password does'nt match.</div> -->
            <!-- <div *ngIf="form.get(formField.name).hasError('minlength') && form.get(formField.name).hasError('pattern')">Minimum characters 8</div>
            <div *ngIf="form.get(formField.name).errors.pattern">Field should contain at least 1 uppercase, 1 lowercase and 1 digit.</div> -->
          </ng-container>
          <!-- <input *ngSwitchCase="'password'" type="password"  [formControlName]="formField.name"  [name]="formField.name" nbInput [status]="isValid?'basic':'danger'" [required]="formField.required?formField.required:null"> -->
          <nb-select *ngSwitchCase="'dropdown'" placeholder="Select" [formControlName]="formField.name" fullWidth selected="formField.value" size="small">
            <nb-option>Reset</nb-option>
            <nb-option *ngFor="let opt of formField.selectOptions" [value]="opt.value">{{opt?.key}}</nb-option>
          </nb-select>
          <input *ngSwitchCase="'textbox'" [formControlName]="formField.name" [name]="formField.name" 
                [id]="formField.key" [type]="formField.controlType" nbInput value="{{formField?.value}}" class="form-control form-control-sm" [status]="isValid?'basic':'danger'" fullWidth fieldSize="small" [required]="formField.required?formField.required:null">
          <ng-container *ngSwitchCase="'datetime'">
            <input [formControlName]="formField.name" nbInput status="basic" fieldSize="small" value="{{formField?.value}}" type="hidden">
            <ubs-ofbiz-date-picker [formField]="formField" (setDateField)="setDateField($event)"></ubs-ofbiz-date-picker>
            <!-- <nb-date-timepicker withSeconds #formcontrol></nb-date-timepicker> -->
            <!-- <nb-datepicker #formcontrol></nb-datepicker> -->
          </ng-container>
          <ng-container *ngSwitchCase="'textarea'">
            <ng-container *ngIf="formField.useEditor;else plainTextArea">
              <ckeditor
                    [formControlName]="formField.name"
                    [(ngModel)] = "formField.value"
                    [config]="{ toolbar: [ 'heading', '|', 'bold', 'italic' ] }"
                    [id]="formField.key">
                </ckeditor>
            </ng-container>
            <ng-template #plainTextArea>
              <textarea [formControlName]="formField.name" [name]="formField.name" [id]="formField.key" nbInput value="{{formField?.value}}" class="form-control form-control-sm" [status]="isValid?'basic':'danger'" fullWidth fieldSize="small" [required]="formField.required?formField.required:null"></textarea>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'file'">
            <input nbInput class="form-control" type="file" [name]="formField.name" id="uploadedFile" (change)="uploadFile($event)" >
          </ng-container>
          <ng-container *ngSwitchCase="'lookup'">
            <input [formControlName]="formField.name" value="{{formField?.value}}" type="hidden">
            <ubs-lookup-field [formField]="formField" (setLookupField)="setLookupField($event)" (openLookupDialogEvent)="openLookupDialog($event)"></ubs-lookup-field>
          </ng-container>
          <ng-container *ngSwitchCase="'image'">
            <div><img [src]="formField?.value"></div>
          </ng-container>
      </div>
  </div>
</ng-template>

